import { Component, OnInit, ViewChild, ViewContainerRef, Input } from '@angular/core';

@Component({
  selector: 'app-view-container',
  templateUrl: './view-container.component.html',
  styleUrls: ['./view-container.component.css']
})
export class ViewContainerComponent implements OnInit {

  @ViewChild('vc', {read: ViewContainerRef}) viewContainerRef: ViewContainerRef;
  @Input() name: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/player/components/view-container/view-container.component.ts